<template>
    <div v-if="!!visible" class="col-lg-12" :colspan="col.colspan">
        <form-input
            v-if="!!col.formReadOnly"
            :showFormLink="false"
            :value="value"
            :label="col.title"
            readonly
        ></form-input>
        <form-select
            v-else-if="col.formType.toLowerCase() == 'select'"
            :name="name"
            :options="col.formOptions"
            :item-label="col.formItemLabel"
            :item-value="col.formItemValue"
            :multiple="col.formMultiple"
            :required="col.formRequired"
            :value="value"
            :values="values"
            :label="col.title"
        ></form-select>
        <form-autocomplete
            v-else-if="col.formType.toLowerCase() == 'autocomplete'"
            :name="name"
            :options="col.formOptions"
            :url="col.formOptionsUrl"
            :item-label="col.formItemLabel"
            :item-value="col.formItemValue"
            :multiple="col.formMultiple"
            :required="col.formRequired"
            :value="value"
            :values="values"
            :label="col.title"
        ></form-autocomplete>
        <form-segment
            v-else-if="col.formType.toLowerCase() == 'segment'"
            :name="name"
            :options="col.formOptions"
            :item-label="col.formItemLabel"
            :item-value="col.formItemValue"
            :required="col.formRequired"
            :value="value"
            :label="col.title"
        ></form-segment>
        <form-checkbox
            v-else-if="col.formType.toLowerCase() == 'checkbox'"
            :name="name"
            :options="col.formOptions"
            :item-label="col.formItemLabel"
            :item-value="col.formItemValue"
            :required="col.formRequired"
            :value="value"
            :values="values"
            :label="col.title"
        ></form-checkbox>
        <form-radio
            v-else-if="col.formType.toLowerCase() == 'radio'"
            :name="name"
            :options="col.formOptions"
            :item-label="col.formItemLabel"
            :item-value="col.formItemValue"
            :required="col.formRequired"
            :value="value"
            :label="col.title"
        ></form-radio>
        <form-file
            v-else-if="col.formType.toLowerCase() == 'file'"
            :name="name"
            :multiple="col.formMultiple"
            :required="col.formRequired"
            :value="value"
            :values="values"
            :label="col.title"
        ></form-file>
        <form-textarea
            v-else-if="col.formType.toLowerCase() == 'textarea'"
            :name="name"
            :required="col.formRequired"
            :value="value"
            :label="col.title"
        ></form-textarea>
        <form-input
            v-else
            :type="col.formType"
            :name="name"
            :showFormLink="false"
            :required="col.formRequired"
            :value="value"
            :min="col.formNumberMin"
            :max="col.formNumberMax"
            :step="col.formNumberStep"
            :label="col.title"
        ></form-input>
    </div>
    <div v-else></div>
</template>

<script>
export default {
    props: {
        col: {
            type: Object,
            default: null,
            required: true
        },
        colIndex: {
            type: Number,
            default: 0,
            required: true
        },
        defaultValue: {
            type: [String, Number, Array],
            default: null,
            required: false
        },
        hideEmpty: {
            type: Boolean,
            default: false,
            required: false
        }
    },
    computed: {
        name: function() {
            return !!this.col.formData
                ? this.col.formData
                : !!this.col.data
                ? this.col.data
                : "formitem_" + this.colIndex;
        },
        value: function() {
            return typeof this.defaultValue === "string" ||
                typeof this.defaultValue === "number"
                ? this.defaultValue
                : null;
        },
        values: function() {
            return typeof this.defaultValue === "array"
                ? this.defaultValue
                : null;
        },
        visible: function() {
            if (!!this.col.formHidden) return false;

            if (!!this.hideEmpty && !!this.col.formReadOnly && !this.value)
                return false;

            return true;
        }
    }
};
</script>
